import { FilterButton } from "@/components/dataPages";
import { capitalizeFirstLetter } from "@/utils/text";
import { ConfidenceLevel } from "@/components/common/svgs/ConfidenceLevel";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";

export const VolumeButton = ({ value, onClick, active, disabled, level }) => {
    const isDarkTheme = useIsDarkTheme();

    return (
        <FilterButton onClick={onClick} active={active} disabled={disabled}>
            <span className="inline-flex flex-row gap-1 items-center">
                <ConfidenceLevel level={level} isDarkTheme={isDarkTheme} />
                {capitalizeFirstLetter(value)}
            </span>
        </FilterButton>
    );
};
